import { render } from "./gradient.vue?vue&type=template&id=2f067c46"
import script from "./gradient.vue?vue&type=script&lang=js"
export * from "./gradient.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./gradient.vue?vue&type=style&index=0&id=2f067c46&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__